<div class="row">
  <div class="col-12">
    <div class="content-header">Business Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="businessForm">
                  <fieldset class="form-group">
                    <label for="name">Name<span class="required_field">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      id="name"
                      placeholder="Enter Name"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.name.invalid,
                        'is-valid':
                          businessFormSubmitted && !rf.name.invalid
                      }"
                      required
                    #name/>
                    <div
                      *ngIf="
                      rf.name.touched &&
                        (rf.name.invalid ||
                          rf.name.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name
                      is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>About</label>
                   <textarea class="form-control" name="about" id="about" formControlName="about" placeholder="Enter about" cols="30" rows="3"></textarea>
                   
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="name">Address</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="address"
                      id="address"
                      placeholder="Enter address"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.address.invalid,
                        'is-valid': businessFormSubmitted && !rf.address.invalid
                      }"
                      />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="Email">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      id="Email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': businessFormSubmitted && rf.email.invalid,
                        'is-valid': businessFormSubmitted && !rf.email.invalid
                      }"
                      required
                      #email
                    />
                    <div
                      *ngIf="rf.email.errors?.email"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Please enter
                      a valid email address
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="name">Website</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="website"
                      id="website"
                      placeholder="Enter Website"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.website.invalid,
                        'is-valid': businessFormSubmitted && !rf.website.invalid
                      }"
                       />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="phone">Phone Number</label>
                    <input
                      placeholder="e.g. 1234-567-890"
                      mask="0000-000-000"
                      minlength="10"
                      type="text"
                      class="form-control"
                      formControlName="phone"
                      id="phone"
                   #phone />
                    <!-- <div
                      *ngIf="
                      rf.phone.touched  && rf.phone.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Phone Number
                      is required
                    </div> -->
                    <div
                    *ngIf="rf.phone.errors?.minlength || rf.phone.errors?.maxlength "
                    class="help-block mt-1 text-danger" >
                    <i class="ft-alert-circle align-middle"></i> Phone no. must be 10 digits </div>
                  </fieldset>
                  
                  <fieldset class="form-group">
                    <label for="type">Business type</label>
                    <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                    placeholder="Select business type" [ngModelOptions]="{standalone: true}" [multiple]="true" [(ngModel)]="selected_type"  (change)="getTypeId($event)"                   
                   >
                  </ng-select>
                    <!-- <div
                      *ngIf="
                      rf.phone.touched  && rf.phone.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Phone Number
                      is required
                    </div> -->
                    <!-- <div
                    *ngIf="rf.phone.errors?.minlength || rf.phone.errors?.maxlength "
                    class="help-block mt-1 text-danger" >
                    <i class="ft-alert-circle align-middle"></i> Phone no. must be 10 digits </div> -->
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="facebook_url">Facebook Url</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="facebook_url"
                      id="facebook_url"
                      placeholder="Enter facebook_url"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.facebook_url.invalid,
                        'is-valid': businessFormSubmitted && !rf.facebook_url.invalid
                      }"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="linked_url">Linked Url</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="linked_url"
                      id="linked_url"
                      placeholder="Enter linked_url"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.linked_url.invalid,
                        'is-valid': businessFormSubmitted && !rf.linked_url.invalid
                      }"
                    />
                  </fieldset>
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="businessForm">
                  
                  <fieldset class="form-group">
                    <label>Refrences</label>
                    <quill-editor (onContentChanged)="setFocus($event)"></quill-editor>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="name">Notes</label>
                    <textarea
                      id="hidden-label-form-6"
                      rows="5"
                      class="form-control"
                      formControlName="notes"
                      id="name"
                      placeholder="Enter  notes"
                      name="comment2"
                      [ngClass]="{
                        'is-invalid': businessFormSubmitted && rf.notes.invalid,
                        'is-valid': businessFormSubmitted && !rf.notes.invalid
                      }"
                      required
                    #notes></textarea>
                    <!-- <div
                      *ngIf="
                      rf.notes.touched &&
                        (rf.notes.invalid || rf.notes.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i>
                      notes is required
                    </div> -->
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
                    <textarea
                      id="hidden-label-form-6"
                      rows="5"
                      class="form-control"
                      formControlName="admin_notes"
                      id="name"
                      placeholder="Enter  Admin Notes"
                      name="comment2"
                      [ngClass]="{
                        'is-invalid':
                          businessFormSubmitted && rf.admin_notes.invalid,
                        'is-valid':
                          businessFormSubmitted && !rf.admin_notes.invalid
                      }"
                      required
                   #admin_notes ></textarea>
                    <!-- <div
                      *ngIf="
                      rf.admin_notes.touched &&
                        (rf.admin_notes.invalid ||
                          rf.admin_notes.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i>
                      admin notess is required
                    </div> -->
                  </fieldset>
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      [disabled]="(name.value.length ===0 )"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
